import { DashboardTab } from "@/types";
import { ROUTES } from "./routes";

export type NavLeaf = { label: string; to: string; tab: DashboardTab };
export type NavGroup = { label: string; key: string; children: NavLeaf[] };
export type NavItem = NavLeaf | NavGroup;

/**
 * Sidebar items, each gated by the tab permission the admin must hold.
 * The role permissions picker groups its tabs by this same layout.
 */
export const NAV_ITEMS: NavItem[] = [
	{ label: "Dashboard", to: ROUTES.Analytics, tab: "TAB_DASHBOARD" },
	{
		label: "Content",
		key: "Content",
		children: [
			{ label: "Courses", to: ROUTES.Courses, tab: "TAB_COURSES" },
			{ label: "SkillSoft", to: ROUTES.SyncLogs, tab: "TAB_SKILLSOFT" },
			{ label: "Categories", to: ROUTES.Categories, tab: "TAB_CATEGORIES" },
			{ label: "Hubs", to: ROUTES.Hubs, tab: "TAB_HUBS" },
			{ label: "Programs", to: ROUTES.Programs, tab: "TAB_PROGRAMS" },
			{ label: "Ta3limy Reels", to: ROUTES.Reels, tab: "TAB_REELS" },
			{ label: "Tags", to: ROUTES.Tags, tab: "TAB_TAGS" },
			{ label: "Providers", to: ROUTES.Providers, tab: "TAB_PROVIDERS" },
			{ label: "Banner", to: ROUTES.Banner, tab: "TAB_BANNER" },
			{
				label: "Landing page banner",
				to: ROUTES.LandingPageBanner,
				tab: "TAB_LANDING_PAGE_BANNER",
			},
		],
	},
	{ label: "Live Session", to: ROUTES.LiveSessions, tab: "TAB_LIVE_SESSIONS" },
	{
		label: "Incentives Management",
		to: ROUTES.Tiers,
		tab: "TAB_INCENTIVES",
	},
	{
		label: "Opportunities",
		to: ROUTES.Opportunities,
		tab: "TAB_OPPORTUNITIES",
	},
	{ label: "Competitions", to: ROUTES.Competitions, tab: "TAB_COMPETITIONS" },
	{
		label: "Content Management",
		key: "Content_Management",
		children: [
			{ label: "Taxonomies", to: ROUTES.Taxonomies, tab: "TAB_TAXONOMIES" },
			{ label: "All Media", to: ROUTES.Media, tab: "TAB_MEDIA" },
		],
	},
	{
		label: "Notifications",
		key: "Notifications",
		children: [
			{
				label: "Manual",
				to: ROUTES.ManualNotification,
				tab: "TAB_MANUAL_NOTIFICATIONS",
			},
			{
				label: "Automatic",
				to: ROUTES.AutomaticNotification,
				tab: "TAB_AUTOMATIC_NOTIFICATIONS",
			},
		],
	},
	{
		label: "Users",
		key: "Users",
		children: [
			{ label: "All Users", to: ROUTES.Users, tab: "TAB_USERS" },
			{
				label: "Active Users",
				to: `${ROUTES.Users}?users-type=active`,
				tab: "TAB_USERS",
			},
			{
				label: "Blocked Users",
				to: `${ROUTES.Users}?users-type=blocked`,
				tab: "TAB_USERS",
			},
			{
				label: "Unverified Users",
				to: `${ROUTES.Users}?users-type=unverified`,
				tab: "TAB_USERS",
			},
		],
	},
	{ label: "Partners", to: ROUTES.Partners, tab: "TAB_PARTNERS" },
	{
		label: "User Feedback",
		key: "UserFeedback",
		children: [
			{
				label: "User Feedback",
				to: ROUTES.UserFeedbackOverview,
				tab: "TAB_USER_FEEDBACK",
			},
			{ label: "Messages", to: ROUTES.Messages, tab: "TAB_MESSAGES" },
		],
	},
	{ label: "Permissions", to: ROUTES.Permisstions, tab: "TAB_ADMINS" },
	{ label: "Roles", to: ROUTES.Roles, tab: "TAB_ROLES" },
];
